//localStorage
export const KEY_TOKEN = "authTkn";
export const KEY_USER_TYPE = "userType"; //user | customer

export const ACCOUNTING_STATUS = {
  0: "Pending Approval",
  1: "In Progress",
  2: "Approved",
  3: "Rejected",
};

export const PRICING_STATUS = {
  0: "Not Ready",
  1: "Invoice Attached",
  2: "Invoice Emailed",
};
export const EDO_IMPORT_STATUS = {
  0: "Hold",
  1: "Partially Issued Document",
  2: "Full Document Issued",
};

export const PAYMENT_MODES = {
  0: "Cash",
  1: "Credit",
  2: "Prepaid",
};

export const DOC_TYPES = {
  BL: "bl",
  NIC: "nic",
  FCL: "fcl",
  BANK_SLIP: "bankSlip",
};

export const ATTACHMENT_TYPES = {
  IMPORT: "import",
  ACCOUNTING: "accounting",
  PRICING: "pricing",
  MDO: "mdo",
};

export const PERMISSIONS = {
  allow: "Allow",
  deny: "Deny",
};

export const ENTRY_STATUSES = [
  "New",
  "Pending Approval",
  "In Progress",
  "Hold",
  "Partially Issued Document",
  "Full Document Issued",
  "Not Ready",
  "Invoice Attached",
  "Invoice Emailed",
];
